import { Link, useMatch, useResolvedPath } from "react-router-dom";

export default function HomeLink({ menu }: any) {
  const { to, icon, name } = menu;
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: false });

  return (
    <div
      className={`flex  justify-center items-center mx-6 text-auto-xxs ${
        match ? "" : ""
      }`}
    >
      <Link to={to}>
        <div className="flex justify-center items-center">
          <div
            className={`flex justify-center items-center bg-toyota rounded-lg ${
              match ? "bg-toyota-pale " : "bg-toyota-dark"
            }`}
          >
            <div className={`text-gray-400 ${match ? "text-white" : "text-gray-400"}`}>{icon}</div>
          </div>
          <div className={`uppercase ml-1  ${match ? "text-white" : "text-gray-400"}`}>
            {name}
          </div>
        </div>
      </Link>
    </div>
  );
}